import hashString from '../../components/hashString';

export default function rlxContactValidation() {
    const $form = $('#rlx-v7-contact__form');
    const $errorMessages = $('.js-rlx-v7-contact__error-message');
    const formUrl = $form.attr('action');
    const hasError = 'has--error';
    const isActive = 'is-active';
    const backButton = document.querySelector('.js-rlx-v7-contact__button-back');
    const nextButton = document.querySelector('.js-rlx-v7-contact__button-next');
    const submitButton = document.querySelector('.js-rlx-v7-contact__button-submit');
    const headlinesStep1 = document.querySelector('.js-rlx-v7-contact__default');
    const headlinesStep2 = document.querySelector('.js-rlx-v7-contact__infos');
    const messageContainer = document.querySelector('.js-rlx-v7-contact__message-container');
    const inputFieldsContainer = document.querySelector('.js-rlx-v7-contact__input-container');
    const titleSelect = document.querySelector('.js-rlx-v7-select__title');
    const teaserBottom = document.querySelector('.js-rlx-v7-contact__teaser-bottom');
    const textSuccess = document.querySelector('.js-rlx-v7-contact__success-title');

    function updateErrors(response) {
        const $rows = $('.js-row');
        const errors = response.responseJSON.errors;

        const rows = [
            [
                $form.find("[name='title']"),
                $form.find("[name='firstName']"),
                $form.find("[name='lastName']"),
            ],
            [
                $form.find("[name='email']"),
                $form.find("[name='phoneCode']"),
                $form.find("[name='phoneNumber']"),
            ],
            [
                $form.find("[name='termsAndConditions']"),
            ],
        ];

        $errorMessages.removeClass(isActive);

        rows.forEach((row, rowIndex) => {
            row.forEach(($field) => {
                const fieldName = $field.attr('name');
                const $parent = $field.parents('.required');
                $parent.removeClass(hasError);
                const error = errors[fieldName];

                if (typeof error !== 'undefined') {
                    $parent.addClass(hasError);
                    let $errorMessage;

                    if (fieldName !== 'email' && fieldName !== 'phoneNumber' && fieldName !== 'phoneCode') {
                        $errorMessage = $rows.eq(rowIndex).find('.rlx-v7-contact__error-message');
                    } else if (fieldName === 'phoneNumber' || fieldName === 'phoneCode') {
                        $errorMessage = $rows.eq(rowIndex).find('.js-rlx-v7-contact__error-message--phone');
                    } else {
                        $errorMessage = $parent.next('.rlx-v7-contact__error-message');
                    }

                    $errorMessage.html(error.message);
                    $errorMessage.addClass(isActive);
                }
            });
        });
        const $firstError = $form.find('.has--error:first');
        $firstError.children(':first').focus();
    }

    $form.submit((e) => {
        e.preventDefault();

        $.post(formUrl, $form.serialize(), () => {
            const $successForm = $('.js-rlx-v7-contact__success');
            const eventName = $form.attr('data-push-mail');
            const inputEmail = $form.find('#email').val();
            const formatInputEmail = inputEmail.toLowerCase();
            const scrollOffset = window.StateManager.isCurrentState(['xs', 's']) ? 100 : 190;

            $successForm.show();
            teaserBottom.classList.remove('_d-none');
            backButton.classList.add('_d-none');
            textSuccess.focus();

            $('.js-rlx-v7-contact__default, .js-rlx-v7-contact__infos').hide();
            $form.hide();

            $('html, body').animate({ scrollTop: $successForm.offset().top - scrollOffset }, 'slow');

            hashString(formatInputEmail).then((hashedMail) => {
                window.dataLayer.push({
                    event: eventName,
                    hashedvalue: hashedMail,
                });
            });

            if (typeof _satellite === 'object') {
                _satellite.track('contactForm'); // eslint-disable-line no-undef
            }
        }).fail((response) => {
            updateErrors(response);
        });
    });

    const toggleElements = (elements, className, condition) => {
        elements.forEach(element => element.classList.toggle(className, condition));
    };

    const handleToggle = (condition) => {
        toggleElements([nextButton, headlinesStep1, messageContainer], '_d-none', condition);
        toggleElements([backButton, headlinesStep2, inputFieldsContainer, submitButton], '_d-none', !condition);
    };

    if (backButton) {
        backButton.addEventListener('click', () => handleToggle(false));
    }
    if (nextButton) {
        nextButton.addEventListener('click', () => {
            handleToggle(true);
            titleSelect.focus();
            window.dataLayer.push({
                event: 'kontaktformular_rolex_step1',
            });
        });
    }
}
